<template>
  <div class="product">
    <div class="index-image">
      <div class="inner-text">
        <p class="title">Contact Us</p>
        <p class="content">We are committed to providing you with professional pre-sale purchasing and consulting services and sophisticated after-sales technical services. </p>
      </div>
    </div>
    <div class="index-next-content">
      <div class="inner-content">
         <el-card shadow="never" class="box-card-inner"
            :style="index%3==1?{marginRight:0}:{}"
            v-for="(item,index) in coreList" :key="index">
            <div class="core">
              <div class="title">
                <img :src="item.icon"/>
              </div>
              <div class="next-title">
                <div class="next-title-one">{{item.title}}</div>
                <div class="next-title-two">{{item.nextTitle}}</div>
              </div>
            </div>
          </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
      coreList: [
        {
          icon: require('../assets/link1.png'),
          title: 'Online customer service',
          nextTitle: 'Staff service: 400-0232-636'
        },
        {
          icon: require('../assets/link2.png'),
          title: 'Email',
          nextTitle: 'iconpt001@hotmail.com'
        },
        {
          icon: require('../assets/link3.png'),
          title: 'Company address',
          nextTitle: 'Chengdu, Sichuan Province'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.product
  padding-bottom 50px
  .index-image
      height:380px
      background-color: rgba(90, 90, 90, 1);
      background-image: url(../assets/bannerbghsy.jpeg);
      background-repeat: no-repeat;
      background-position: center
     .inner-text
      padding-top 100px
      margin 0 auto
      width 880px
      color #fff
      .title
        margin 0 auto
      .content
        width 500px
        font-size 14px
        line-height 30px
  .index-next-content
     width 100%
     margin-top 50px
    .inner-content
      width: 1100px
      margin 0 auto
      display flex
    .box-card-inner
        text-align center
        margin 10px 15px
        width: 30%
        border-radius: 10px
        display: inline-block
        padding 30px 10px
        .title
          height 80px
        .next-title
          color rgba(128, 128, 128, 1)
          font-size 12px
          .next-title-two
            font-weight 500
            font-size 14px
            padding-top 20px
          .next-title-one
            font-weight 600
            padding-top 30px
            font-size 18px
</style>



// WEBPACK FOOTER //
// src/pages/service.vue